var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandle2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.061,
    height: 65,
    viewBox: "0 0 37.061 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "candle-2",
    transform: "translate(-110.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(110.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M144.584,28.337a6.18,6.18,0,0,0-5.514-.97,36.584,36.584,0,0,1-8.618,1.5v-2.9a10.206,10.206,0,0,0,8.3-10.013c0-2.243-1.361-5.311-4.159-9.38-2.012-2.925-4.122-5.408-4.523-5.875a1.988,1.988,0,0,0-3.016,0c-.4.468-2.512,2.951-4.524,5.876-2.8,4.069-4.159,7.137-4.159,9.38a10.206,10.206,0,0,0,8.268,10.006v2.906a36.591,36.591,0,0,1-8.58-1.494,6.236,6.236,0,0,0-8.027,5.973V59.114A5.893,5.893,0,0,0,115.922,65h25.289a5.893,5.893,0,0,0,5.886-5.886V33.339A6.18,6.18,0,0,0,144.584,28.337Zm-22.4-12.389c0-2.165,3.025-6.939,6.381-11.112,3.356,4.172,6.381,8.947,6.381,11.112a6.393,6.393,0,0,1-4.494,6.1V19.432a1.9,1.9,0,1,0-3.809,0v2.6A6.393,6.393,0,0,1,122.183,15.948Zm21.1,43.166a2.079,2.079,0,0,1-2.077,2.077H115.922a2.079,2.079,0,0,1-2.077-2.077V33.339a2.43,2.43,0,0,1,2.419-2.428,2.45,2.45,0,0,1,.7.1,40.263,40.263,0,0,0,23.2,0,2.426,2.426,0,0,1,3.123,2.324V59.114Z",
    transform: "translate(-110.036)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandle2);
export default __webpack_public_path__ + "static/media/candle-2.a4a67c2aab7130dc64a77c1616ca3be0.svg";
export { ForwardRef as ReactComponent };